import { render, staticRenderFns } from "./ESGScopeTableByName.vue?vue&type=template&id=d085e866"
import script from "./ESGScopeTableByName.vue?vue&type=script&lang=js"
export * from "./ESGScopeTableByName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports